export default "__VITE_ASSET__4fd85898__"